import { TableRow, TableCell, Typography, Button } from '@mui/material';

// ----------------------------------------------------------------------

export default function ChannelSelectionTableRow({ row, selectContentHandler }) {
  const { RowNum, SocialManagerChannelID, SocialManagerChannelName } = row;

  return (
    <TableRow hover>
      <TableCell align="center">
        <Typography variant="body1">{RowNum}</Typography>
      </TableCell>

      <TableCell className="fixed-table-cell" align="center">
        <Typography variant="body1">{SocialManagerChannelID}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{SocialManagerChannelName}</Typography>
      </TableCell>

      <TableCell align="right">
        <Button color="warning" variant="contained" onClick={() => selectContentHandler(row)}>
          انتخاب
        </Button>
      </TableCell>
    </TableRow>
  );
}
